import { CLienteAPi } from "../client_api";

//getUsuarios
export class peticion_Usuarios_Lista {
    ConexionIacpos: number;
    clienteAPI: CLienteAPi;
    NombreUsuario: string;
    iTipoUsuario: number;
}